import React, { FunctionComponent, Fragment } from "react"
import { Theme, makeStyles } from "@material-ui/core"
import { useTranslation } from "react-i18next"
import { TopBar } from "../partials/heading/TopBar"
import { RfidManagementPageContent } from "../partials/rfid-management/RfidManagementPageContent"

const useStyles = makeStyles((theme: Theme) => ({}))

interface IRfidManagementPageProps {}

export const RfidManagementPage: FunctionComponent<IRfidManagementPageProps> = (props) => {
  const classes = useStyles()
  const { t } = useTranslation()

  return (
    <Fragment>
      <TopBar>{t("rfid_management.heading")}</TopBar>

      <RfidManagementPageContent />
    </Fragment>
  )
}
